module.exports = __webpack_public_path__ + "static/media/diaphragm.0751b7b0.svg";